import html2canvas from "html2canvas";
import _ from "lodash";

export const baseApiUrl = process.env.REACT_APP_API_URL;
export const apiUrls = {
   countryListUrl: baseApiUrl + "GetUserCountries?userid=",
   GetScenarioforQuotaDefinition:
      baseApiUrl + "Define/GetScenarioforQuotaDefinition?countryId=",
   GetQuotaPeriods: baseApiUrl + "Define/GetQuotaPeriods?scenarioId=",
   GetWeeklyDepletion: baseApiUrl + "Define/GetWeeklyDepletion",
   GetWeeklyDepletionValues: baseApiUrl + "Define/GetWeeklyDepletionValues",
   GetSKUOrPGByScenario: baseApiUrl + "Define/GetSKUOrPGByScenario?ScenarioID=",
   GetQuotaDetails: baseApiUrl + "Define/GetQuotaDetails?",
   GetQuotaChartData: baseApiUrl + "Define/GetQuotaChartData",
   SaveQuota: baseApiUrl + "Define/SaveQuota",
   SubmitQuota: baseApiUrl + "Define/SubmitQuota",
   ExportExcel: baseApiUrl + "Define/ExportExcel",
   ImportExcel: baseApiUrl + "Define/ImportExcel",
   GetDSAData: baseApiUrl + "Scenario/GetDataSourceAlignmentData?",
   exportFile: baseApiUrl + "Define/ExportFile?",
   Upload: baseApiUrl + "Approve/Upload",
   Downloadfile: baseApiUrl + "Define/DownloadFile?",
};

export const views = [
   { key: 1, value: "Detailed View" },
   { key: 2, value: "SKU Name, SKU No, Cust Name, Cust No, Quota" },
];

export function catchElement(className) {
   const element = document.querySelector(className);
   if (!element) {
      console.log("Element not found");
      return;
   }
   return element;
}

export async function elementToBase64(element) {
   try {
      const canvas = await html2canvas(element);
      return canvas.toDataURL("image/png");
   } catch (error) {
      console.log(
         "An error occurred while converting the element to base64:",
         error
      );
      return null;
   }
}

export function prepareGridData(data, initialForecast) {
   if (data) {
      const rows = data.map((item, index) => {
         return {
            id: index,
            quotaID: item.quotaID,
            customerQuotaID: item.customerQuotaID,
            skuid: item.skuid,
            skuName: item.skuName,
            skuNumb: item.skuNumb,
            productGroupID: item.productGroupID,
            packID: item.packID,
            packName: item.packName,
            skuType: item.skuType,
            customerGroupID: item.customerGroupID,
            customerGroupName: item.customerGroupName,
            customerNumber: item.customerNumber,
            type: item.type,
            unquieID: item.unquieID,
            ID: item.id, // actual prop is id from the API.
            name: item.name,
            customerID: item.customerID,
            customerName: item.customerName,
            initialQuota: item.initialQuota,
            sharePercentage: item.sharePercentage,
            customerSharePercentage: item.customerSharePercentage,
            safetyMargin: item.safetyMargin,
            tender: item.tender,
            adjustment: item.adjustment,
            weekly1: !item.weekly1 ? 0 : item.weekly1,
            weekly2: !item.weekly2 ? 0 : item.weekly2,
            weekly3: !item.weekly3 ? 0 : item.weekly3,
            weekly4: !item.weekly4 ? 0 : item.weekly4,
            weekly5: !item.weekly5 ? 0 : item.weekly5,
            weekly1Per: item.weekly1Per,
            weekly2Per: item.weekly2Per,
            weekly3Per: item.weekly3Per,
            weekly4Per: item.weekly4Per,
            weekly5Per: item.weekly5Per,
            quota: item.quota,
            sit: item.sit,
            customerQuotaComments: item.customerQuotaComments,
            totalQuota: item.totalQuota,
            minimumQuota: item.minimumQuota,
            customerTrustLevel: item.customerTrustLevel,
            q1Ratio: item.q1Ratio,
            q2Ratio: item.q2Ratio,
            unusedQuota: item.unusedQuota,
            isBuffer: item.isBuffer,
            skuPercentage: item.skuPercentage,
            initialForecast,
            hasError: false,
         };
      });
      console.log("Define_defineUtils_prepareGridData", rows);
      return rows;
   }
   return [];
}

export function addWeeklyDepletionValuesToGrid(data, values) {
   if (data) {
      const rows = data.map((item) => {
         return {
            ...item,
            weekly1Per: values.week1,
            weekly2Per: values.week2,
            weekly3Per: values.week3,
            weekly4Per: values.week4,
            weekly5Per: values.week5,
         };
      });
      console.log("Define_defineUtils_addWeeklyDepletionValuesToGrid", rows);
      return rows;
   }
   return [];
}

export function getAllCustomerTypes(list) {
   if (list) {
      const types = list.map((item, index) => {
         return item.type;
      });
      const customerTypes = Array.from(new Set(types));
      return customerTypes;
   }
   return [];
}

export function getAllCustomerTrustLevels(list) {
   if (list) {
      const levels = list.map((item, index) => {
         return item.customerTrustLevel;
      });
      const custLevels = Array.from(new Set(levels));
      return custLevels;
   }
   return [];
}

export function prepareCustomers(gridData, gridDataFiltered) {
   console.log("prepareCustomers funtion started at ", new Date().toISOString());
   let customers = [];
   // let gridData = _.cloneDeep(mainList);
   // let gridDataFiltered = _.cloneDeep(filteredList);
   let map = {};
   for (let i = 0; i < gridDataFiltered.length; ++i) {
      let item = gridDataFiltered[i];
      map[item.id] = item;
   }
   for (let i = 0; i < gridData.length; ++i) {
      const gridItem = gridData[i];
      const filGridItem = map[gridItem.id];
      // console.log("filGridItem", filGridItem);
      if (filGridItem) {
         customers.push(filGridItem);
      } else {
         customers.push(gridItem);
      }
   }
   console.log("prepareCustomers funtion ended at ", new Date().toISOString());
   return customers;
}

export function validateCustomers(customers, depletion) {
   console.log("validateCustomers funtion started at", new Date().toISOString());
   let list = [];
   for (let i = 0; i < customers.length; ++i) {
      const customer = customers[i];
      // console.log("validateCustomers_customer", customer);
      let notNull = true;
      let validValues = true;
      if (depletion === "biweekly") {
         notNull =
            customer.weekly1 !== null &&
            customer.weekly1 !== undefined &&
            !isNaN(customer.weekly1) &&
            customer.weekly2 !== null &&
            customer.weekly2 !== undefined &&
            !isNaN(customer.weekly2);

         validValues = customer.weekly1 <= customer.weekly2;
      } else if (depletion !== "None") {
         notNull =
            customer.weekly1 !== null &&
            customer.weekly1 !== undefined &&
            !isNaN(customer.weekly1) &&
            customer.weekly2 !== null &&
            customer.weekly2 !== undefined &&
            !isNaN(customer.weekly2) &&
            customer.weekly3 !== null &&
            customer.weekly3 !== undefined &&
            !isNaN(customer.weekly3) &&
            customer.weekly4 !== null &&
            customer.weekly4 !== undefined &&
            !isNaN(customer.weekly4) &&
            customer.weekly5 !== null &&
            customer.weekly5 !== undefined &&
            !isNaN(customer.weekly5);
         validValues =
            customer.weekly1 <= customer.weekly2 &&
            customer.weekly2 <= customer.weekly3 &&
            customer.weekly3 <= customer.weekly4 &&
            customer.weekly4 <= customer.weekly5;
      }
      if (!notNull || !validValues) {
         console.log("validateCustomers funtion ended with validation error at ", new Date().toISOString());
         return `Invalid value given for ${
            customer.customerName
               ? customer.customerName
               : customer.customerGroupName
         }`;
      }
      list.push({
         customerGroupID: customer.customerGroupID,
         customerID: customer.customerID,
         initialQuota: customer.initialQuota,
         safetyMargin: customer.safetyMargin,
         unusedQuota: customer.unusedQuota,
         tender: customer.tender,
         adjustment: customer.adjustment,
         weekly1: !customer.weekly1 ? 0 : customer.weekly1,
         weekly2: !customer.weekly2 ? 0 : customer.weekly2,
         weekly3: !customer.weekly3 ? 0 : customer.weekly3,
         weekly4: !customer.weekly4 ? 0 : customer.weekly4,
         weekly5: !customer.weekly5 ? 0 : customer.weekly5,
         customerQuotaComments: customer.customerQuotaComments,
         skuid: customer.skuid,
         productGroupID: customer.productGroupID,
         quota: customer.quota,
      });
   }
   console.log("validateCustomers funtion ended at ", new Date().toISOString());
   return list;
}

export function prepareList1(customers) {
   let list1 = customers.map((item, index) => {
      return {
         quotaID: item.quotaID,
         customerQuotaID: item.customerQuotaID,
         skuid: item.skuid,
         skuName: item.skuName,
         skuNumb: item.skuNumb,
         productGroupID: item.productGroupID,
         packID: item.packID,
         packName: item.packName,
         skuType: item.skuType,
         customerGroupID: item.customerGroupID,
         customerGroupName: item.customerGroupName,
         customerNumber: item.customerNumber,
         type: item.type,
         unquieID: item.unquieID,
         id: item.ID,
         name: item.name,
         customerID: item.customerID,
         customerName: item.customerName,
         initialQuota: item.initialQuota,
         sharePercentage: item.sharePercentage,
         customerSharePercentage: item.customerSharePercentage,
         safetyMargin: item.safetyMargin,
         tender: item.tender,
         adjustment: item.adjustment,
         weekly1: !item.weekly1 ? 0 : item.weekly1,
         weekly2: !item.weekly2 ? 0 : item.weekly2,
         weekly3: !item.weekly3 ? 0 : item.weekly3,
         weekly4: !item.weekly4 ? 0 : item.weekly4,
         weekly5: !item.weekly5 ? 0 : item.weekly5,
         weekly1Per: item.weekly1Per,
         weekly2Per: item.weekly2Per,
         weekly3Per: item.weekly3Per,
         weekly4Per: item.weekly4Per,
         weekly5Per: item.weekly5Per,
         quota: item.quota,
         sit: item.sit,
         customerQuotaComments: item.customerQuotaComments,
         totalQuota: item.totalQuota,
         minimumQuota: item.minimumQuota,
         customerTrustLevel: item.customerTrustLevel,
         q1Ratio: item.q1Ratio,
         q2Ratio: item.q2Ratio,
         unusedQuota: item.unusedQuota,
         isBuffer: item.isBuffer,
         skuPercentage: item.skuPercentage,
      };
   });
   return list1;
}

export function prepareList2(customers) {
   console.log("prepareList2 funtion started at", new Date().toISOString());
   let list2 = customers.map((item, index) => {
      console.log("prepareList2_item", item);
      return {
         customerGroupID: item.customerGroupID,
         customerID: item.customerID,
         initialQuota: item.initialQuota,
         safetyMargin: item.safetyMargin,
         unusedQuota: item.unusedQuota,
         tender: item.tender,
         adjustment: item.adjustment,
         weekly1: !item.weekly1 ? 0 : item.weekly1,
         weekly2: !item.weekly2 ? 0 : item.weekly2,
         weekly3: !item.weekly3 ? 0 : item.weekly3,
         weekly4: !item.weekly4 ? 0 : item.weekly4,
         weekly5: !item.weekly5 ? 0 : item.weekly5,
         customerQuotaComments: item.customerQuotaComments,
         skuid: item.skuid,
         productGroupID: item.productGroupID,
         quota: item.quota,
      };
   });
   console.log("prepareList2 funtion ended at", new Date().toISOString());
   return list2;
}

export function getQuotaTableData(columns, data) {
   console.log(columns, data);
   const cols = getQuotaTableColumns(data);
   const rows = getQuotaTableRows(data, columns);
   return { rows, cols };
}

function getQuotaTableColumns(data) {
   let columns = [{ field: "data", headerName: "Data", width: 120 }];

   let counts = {};
   let rowData = [];

   data.forEach((row, index) => {
      let date = row[0].split(",")[0];
      if (counts[date] !== undefined) {
         counts[date] += 1;
         rowData.push(`${date}_${counts[date]}`);
      } else {
         counts[date] = 0;
         rowData.push(row[0].split(",")[0]);
      }
   });

   data.forEach((row, index) => {
      console.log(`${index}: ${JSON.stringify(row)}`);
  });

   rowData.forEach((array, index) => {
      const colName = array;
      const col = {
         field: colName,
         headerName: colName.split("_")[0],
         disableColumnMenu: true,
         filterable: false,
         hideSortIcons: true,
         width: 90,
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString();
            return formattedValue;
         },
      };
      columns.push(col);
   });
   console.log("getQuotaTableColumns", columns);
   return columns;
}

function getQuotaTableRows(data, columns) {
   let newData = [];
   data.forEach((array) => {
      const nestedArray = array[0].split(",");
      newData.push(nestedArray);
   });

   let counts = {};
   newData.forEach((row, index) => {
      let date = row[0];
      if (counts[date] !== undefined) {
         counts[date] += 1;
         row[0] = `${date}_${counts[date]}`;
      } else {
         counts[date] = 0;
      }
   });
   console.log("getQuotaTableRows_newData", newData);

   let rows = [];
   let id = 1;

   for (let i = 1; i < columns.length; ++i) {
      const Data = columns[i];
      let row = { id };
      row = { ...row, data: Data };
      ++id;

      for (let j = 0; j < newData.length; ++j) {
         if (newData[j][i] === "null") {
            row[newData[j][0]] = "";
         } else {
            row[newData[j][0]] = newData[j][i];
         }
      }
      rows.push(row);
   }
   console.log("getQuotaTableRows_rows", rows);
   return rows;
}

export function formatNumber(num) {
   console.log("Input ", num);
   let numStr = Math.abs(num).toString();
   let len = numStr.length;
   if (len <= 3) {
       return num.toString(); // No formatting needed for numbers <= 999
   }
   let output = "";
   const positions = [2, 4, 6];
   let p = 0;
   for(let i = numStr.length - 1; i >= 0; --i) {
      if(positions.includes(p) && i !== 0) {
         output = "," + numStr[i] + output;
      }
      else {
         output = numStr[i] + output;
      }
      ++p;
   }
   console.log("Output ", output);
   return output;
}

export function removeComma(str) {
   let formattedString = "";
   for (let i = 0; i < str.length; i++) {
      if (str[i] !== ",") {
         formattedString += str[i];
      }
   }
   return formattedString;
}

export const sizes = {
   w650: 650,
   w450: 450,
   w300: 300,
   w270: 270,
   w250: 250,
   w200: 200,
   w150: 150,
   h35: 35,
};
